import {Members} from '../../components/dash';

export default Members;